module.exports = __webpack_public_path__ + "static/media/Juliana_Borges_Praticando_Samavritti.bb2d40ad.jpg";